import FroalaEditor from 'froala-editor';
import {
    createCheckbox,
    createInput,
    createColorElement,
    createPadding
} from '../utils/froalaElement.js';

(function () {
    if (typeof window === 'undefined') {
        return;
    }
    // 設定 Popup 模板
    FroalaEditor.POPUP_TEMPLATES = {
        ...FroalaEditor.POPUP_TEMPLATES, // 保留現有的模板
        'link.edit': '[_BUTTONS_]',
        'customPlugin.button': '[_BUTTONS_][_CUSTOM_LAYER_]',
        'customPlugin.buttonTextColor': '[_BUTTONS_][_CUSTOM_LAYER_]',
        'customPlugin.buttonBackground': '[_BUTTONS_][_CUSTOM_LAYER_]',
        'customPlugin.buttonAlign': '[_BUTTONS_][_CUSTOM_LAYER_]',
        'customPlugin.buttonPadding': '[_CUSTOM_LAYER_]',
        'customPlugin.buttonStyle': '[_CUSTOM_LAYER_]',
        'customPlugin.buttonBorder': '[_BUTTONS_][_CUSTOM_LAYER_]'
    };

    // 定義預設按鈕屬性
    FroalaEditor.DEFAULTS = {
        ...FroalaEditor.DEFAULTS, // 保留現有的預設值
        buttonDefault: {
            //title
            text: 'Button',
            //文字顏色
            textColor: '#ffffff',
            //背景顏色
            bgColor: '#e25041',
            //上下間距
            paddingTopBottom: '10px',
            //左右間距
            paddingLeftRight: '20px',
            //圓角
            radius: '4',
            //實心 空心 純文字
            btnStyle: 'solid',
            //對齊：
            align: 'left',
            borderColor: 'transparent',
            fontSize: '24'
        }
    };

    //插入按鈕 及 按下按鈕toolbar
    FroalaEditor.PLUGINS.customButton = function (editor) {
        function initPopup() {
            const input = `
              <div class="fr-layer fr-active custom-popup">
                <div class="fr-option-container fr-laptop-full">
                  <div class="fr-laptop-group">
                    ${createInput({ id: editor.id, className: 'custom-button-text-input', name: 'href', labelName: translate('button_href') })}
                  </div>
                  <div class="fr-laptop-full">
                    ${createInput({ id: editor.id, className: 'custom-button-text-input', name: 'text', labelName: translate('button_text') })}
                    ${createCheckbox({ id: editor.id, className: 'custom-button-checkbox-input', name: 'target', labelName: translate('blank_link') })}
                  </div>
                </div>
                <div class="fr-action-buttons">
                  <button class="fr-command fr-submit" role="button" data-cmd="addButton" tabindex="4" type="button">
                    ${translate('Insert')}
                  </button>
                </div>
              </div>
            `;

            const template = {
                custom_layer: input,
                buttons: ''
            };
            const popup = editor.popups.create('customPlugin.button', template);

            return popup;
        }
        function showPopup() {
            let popup = editor.popups.get('customPlugin.button');

            // 如果 popup 不存在，則創建它。
            if (!popup) popup = initPopup();
            popup[0].classList.remove('second-popup');
            editor.popups.setContainer('customPlugin.button', editor.$tb);

            const selection = editor.selection.element();
            resetValue(selection);

            // 獲取工具欄上的按鈕對象，以便相對於它顯示 popup。
            const $btn = editor.$tb.find('.fr-command[data-cmd="customButton"]');

            // 設置 popup 的位置。
            const left = $btn.offset().left + $btn.outerWidth() / 2;
            const top =
                $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);

            // 按鈕的 height 需要顯示 popup 在按鈕上方的情況。
            editor.popups.show('customPlugin.button', left, top, $btn.outerHeight());
        }
        function hidePopup() {
            editor.popups.hide('customPlugin.button');
        }
        function createButton() {
            const values = getPopupInputValue();
            const {
                href = '#\u00A0',
                text = '',
                fontSize = '24',
                textColor = '#ffffff',
                bgColor = '#e25041',
                radius = '5',
                borderColor = 'transparent',
                target = true
            } = values;
            const finalHref = href.trim() === '' || href.trim() === '#\u00A0' ? '#\u00A0' : href;
            const options = target ? { target: '_blank' } : { target: null };
            // 這邊實作上 Append 的是 <a></a> 而不是 <button></button>。實測發現 insert 會自動將 Popup 關閉
            editor.link.insert(finalHref, text, options);

            const link = editor.link.get();
            // a 元素上設定 custom-button-plugin className 來識別是客製化建立
            if (!link.classList.contains('custom-button-plugin')) {
                link.classList.add('custom-button-plugin');
            }

            // 移除外部的 <strong>，並手動包裹文字
            link.innerHTML = `<strong>${text}</strong>`;

            const style_button = `
                display:inline-block;
                margin: 8px;
                padding: 10px 20px;
                letter-spacing: 1px;
                text-decoration: none !important; 
                cursor: pointer;
            `;

            link.setAttribute('style', style_button);
            link.style.fontSize = `${parseInt(fontSize)}px`;
            link.style.color = textColor;
            link.style.backgroundColor = bgColor;
            link.style.borderRadius = `${parseInt(radius)}px`;
            link.style.borderColor = borderColor;

            if (finalHref === '#\u00A0') link.setAttribute('href', '');
        }
        function getPopupInputValue() {
            // 取得 Popup 中輸入的數值
            const popup = editor.popups.get('customPlugin.button');
            const textInputs = popup[0].querySelectorAll('input.custom-button-text-input');
            const checkboxInputs = popup[0].querySelectorAll('input.custom-button-checkbox-input');
            const values = {};

            textInputs.forEach(input => {
                values[input.getAttribute('name')] = input.value;
            });
            checkboxInputs.forEach(input => {
                values[input.getAttribute('name')] = input.checked;
            });
            return values;
        }
        function updateButton() {
            const values = getPopupInputValue();
            const { href = '#\u00A0', text = '', target = true } = values;
            const finalHref = href.trim() === '' || href.trim() === '#\u00A0' ? '#\u00A0' : href;
            // 獲取當前的鏈接
            const link = editor.link.get();

            // 更新文字內容
            link.innerHTML = `<strong>${text}</strong>`;
            // 更新 href
            link.setAttribute('href', finalHref);
            // 更新 target 屬性
            if (target) link.setAttribute('target', '_blank');
            else link.removeAttribute('target');
            // 如果 href 是空白，清除 href
            if (finalHref === '#\u00A0') link.setAttribute('href', '');
            hidePopup();
        }
        function showEdit() {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            let popup = editor.popups.get('customPlugin.button');

            if (!popup) popup = initPopup();
            popup[0].classList.add('second-popup');
            editor.popups.setContainer('customPlugin.button', editor.$sc);
            resetValue(selectOuterElement);

            const link = editor.link.get();
            const linkRect = link.getBoundingClientRect();
            const left = linkRect.left + linkRect.width / 2;
            const top = linkRect.top + linkRect.height + window.pageYOffset;

            editor.popups.show('customPlugin.button', left, top, linkRect.height);
        }
        function resetValue(selection) {
            let button = selection;
            const hasButton = button.classList.contains('custom-button-plugin');
            const { text: defaultText } = editor.opts.buttonDefault;
            const btnUrl = hasButton ? button.getAttribute('href') : '';
            const btnTarget = hasButton ? button.getAttribute('target') : '';
            const btnText = hasButton ? button.textContent : defaultText;
            const popup = editor.popups.get('customPlugin.button');

            popup[0].querySelector('input[name="href"]').value = btnUrl;
            popup[0].querySelector('input[name="text"]').value = btnText;
            popup[0].querySelector('input[name="target"]').checked = Boolean(btnTarget);
        }
        function translate(word) {
            return editor.language.translate(word);
        }
        function getLinkSelector() {
            let element = editor.image ? editor.image.get() : null;
            if (!element && editor.$wp) {
                let commonAncestor = editor.selection.ranges(0).commonAncestorContainer;

                try {
                    if (
                        (commonAncestor &&
                            commonAncestor.contains &&
                            commonAncestor.contains(editor.el)) ||
                        !editor.el.contains(commonAncestor) ||
                        editor.el === commonAncestor
                    ) {
                        commonAncestor = null;
                    }
                } catch (error) {
                    commonAncestor = null;
                }

                if (
                    commonAncestor &&
                    commonAncestor.nodeType === Node.ELEMENT_NODE &&
                    commonAncestor.tagName === 'A'
                ) {
                    return commonAncestor;
                }

                let startElement = editor.selection.element();
                let endElement = editor.selection.endElement();

                if (startElement.nodeType === Node.ELEMENT_NODE && startElement.tagName !== 'A') {
                    startElement = findParent(startElement, 'A');
                }

                if (endElement.nodeType === Node.ELEMENT_NODE && endElement.tagName !== 'A') {
                    endElement = findParent(endElement, 'A');
                }

                try {
                    if (
                        (endElement && endElement.contains && endElement.contains(editor.el)) ||
                        !editor.el.contains(endElement) ||
                        editor.el === endElement
                    ) {
                        endElement = null;
                    }
                } catch (error) {
                    endElement = null;
                }

                try {
                    if (
                        (startElement &&
                            startElement.contains &&
                            startElement.contains(editor.el)) ||
                        !editor.el.contains(startElement) ||
                        editor.el === startElement
                    ) {
                        startElement = null;
                    }
                } catch (error) {
                    startElement = null;
                }

                return endElement &&
                    endElement === startElement &&
                    endElement.nodeType === Node.ELEMENT_NODE &&
                    endElement.tagName === 'A'
                    ? (editor.browser.msie || editor.helpers.isMobile()) &&
                      (editor.selection.info(startElement).atEnd ||
                          editor.selection.info(startElement).atStart)
                        ? null
                        : startElement
                    : null;
            }
            return editor.el.nodeType === Node.ELEMENT_NODE && editor.el.tagName === 'A'
                ? editor.el
                : element &&
                    element.parentNode &&
                    element.parentNode.nodeType === Node.ELEMENT_NODE &&
                    element.parentNode.tagName === 'A'
                  ? element.parentNode
                  : undefined;
        }
        // Helper function to find the closest parent with a specific tag
        function findParent(element, tagName) {
            while (element && element.nodeType === Node.ELEMENT_NODE) {
                if (element.tagName === tagName) {
                    return element;
                }
                element = element.parentNode;
            }
            return null;
        }
        function setLinkEditPopup() {
            const link = getLinkSelector();
            if (!link) return;

            editor.popups.get('link.edit')[0].classList.add('second-popup');
            /**
             * 由與連結與客製化按鈕皆是使用 linkEditButtons 設定，因此，在點擊連結文字與客製化按鈕要將隱藏 PopUp 指定按鈕
             */
            const customButtonList = [
                '.fr-popup.fr-active .fr-command[data-cmd="buttonEdit"]', // 按鈕
                '.fr-popup.fr-active .fr-command[data-cmd="backgroundColorEdit"]', // 背景顏色
                '.fr-popup.fr-active .fr-command[data-cmd="borderOuterButton"]', // 邊框
                '.fr-popup.fr-active .fr-command[data-cmd="textColorEdit"]', // 文字顏色
                '.fr-popup.fr-active .fr-command[data-cmd="buttonPadding"]', // 間距
                '.fr-popup.fr-active .fr-command[data-cmd="buttonAlign"]', // 對齊
                '.fr-popup.fr-active .fr-command[data-cmd="buttonStyle"]', // 按鈕樣式
                '.fr-popup.fr-active .fr-separator.fr-vs[role="separator"]' // 分隔線
            ];
            const linkList = [
                '.fr-popup.fr-active .fr-command[data-cmd="linkEdit"]', // 編輯連結
                '.fr-popup.fr-active .fr-command[data-cmd="linkOpen"]', // 開啟連結
                '.fr-popup.fr-active .fr-command[data-cmd="linkRemove"]' // 移除連結
            ];

            [...customButtonList, ...linkList].forEach(source => {
                const elem = document.querySelector(source);

                if (Boolean(elem)) {
                    if (link.classList.contains('custom-button-plugin')) {
                        // 點擊客製化按鈕
                        if (customButtonList.includes(source)) {
                            if (elem.style.display === 'none') elem.style.display = '';
                        } else elem.style.display = 'none';
                    } else {
                        // 點擊文字連結
                        if (linkList.includes(source)) {
                            if (elem.style.display === 'none') elem.style.display = '';
                        } else elem.style.display = 'none';
                    }
                    elem.classList.add('fr-selection');
                }
            });
        }
        return {
            _init: function () {
                editor.events.on('popups.show.link.edit', function () {
                    setLinkEditPopup();
                });
            },
            showPopup,
            hidePopup,
            createButton,
            updateButton,
            showEdit
        };
    };
    // Define an icon and command for the button that opens the custom popup.
    FroalaEditor.DefineIcon('customButton', {
        SRC: 'https://assets.fevercdn.com/nc/froala_editor/add_button.png',
        ALT: 'fr-custom icon-button',
        template: 'image'
    });
    FroalaEditor.RegisterCommand('customButton', {
        title: 'button_InsertButton',
        undo: false,
        focus: true,
        refreshOnCallback: true,
        popup: true,
        plugin: 'customButton',
        callback() {
            if (this.popups.isVisible('customPlugin.button')) {
                this.popups.hide('customPlugin.button');
            } else {
                this.customButton.showPopup();
            }
        }
    });
    FroalaEditor.RegisterCommand('addButton', {
        title: 'addButton',
        icon: 'buttonIcon',
        undo: true,
        focus: false,
        callback: function () {
            let popup = this.popups.get('customPlugin.button');

            if (popup[0] && popup[0].classList.contains('second-popup')) {
                this.customButton.updateButton();
            } else this.customButton.createButton();
        },
        plugin: 'addButton'
    });
    //編輯按鈕
    FroalaEditor.DefineIcon('buttonEdit', {
        NAME: 'pencil',
        SVG_KEY: 'edit'
    });
    FroalaEditor.RegisterCommand('buttonEdit', {
        title: 'button_EditButton',
        undo: false,
        refreshAfterCallback: false,
        popup: true,
        callback: function () {
            this.customButton.showEdit();
        },
        plugin: 'customButton'
    });

    //背景顏色
    FroalaEditor.PLUGINS.buttonBackground = function (editor) {
        // Define the popup template
        function initPopup() {
            let popup_buttons = '';

            const colorElement = createColorElement({
                id: editor.id,
                containerClassName: 'fr-background-color',
                colorPickFunc: 'setBackgroundColor',
                saveFunc: 'setBackgroundColor',
                saveText: translate('OK'),
                clearText: translate('Clear Formatting'),
                colorLabel: translate('HEX Color'),
                opacityLabel: translate('opacity')
            });

            const template = {
                buttons: popup_buttons,
                custom_layer: colorElement
            };
            const popup = editor.popups.create('customPlugin.buttonBackground', template);
            return popup;
        }
        function refreshOnShow(popup) {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            const isSelectCustomButton =
                Boolean(selectOuterElement) &&
                selectOuterElement.classList.contains('custom-button-plugin');

            if (!isSelectCustomButton) return;

            // 從選中按鈕中獲取背景顏色
            let bgColor = getComputedStyle(selectOuterElement).backgroundColor;

            // 移除之前選擇的顏色
            removeColor(popup);
            if (bgColor) {
                let transparent = null;
                if (bgColor.indexOf('rgba') !== -1) {
                    // 將 RGBA 轉換為 RGB 和透明度
                    ({ transparent, color: bgColor } = convertRGBAToObj(bgColor));
                }
                // 在彈出窗口中重新選擇顏色
                reSelectColor(bgColor, transparent, popup);
            }
        }
        function reSelectColor(color, transparent, popup) {
            const hexColor = editor.helpers.RGBToHex(color);
            const colorItem = popup[0].querySelector(
                `.fr-background-color .fr-select-color[data-param1="${hexColor}"]`
            );
            if (colorItem) {
                colorItem.innerHTML +=
                    '<span class="fr-selected-color" aria-hidden="true">\uf00c</span>';
                colorItem.classList.add('fr-active-item');
                colorItem.setAttribute('aria-selected', 'true');
            }
            const colorInput = popup[0].querySelector('.fr-background-color .fr-color input');
            if (colorInput) {
                editor.selection.save();
                colorInput.value = hexColor;
                colorInput.classList.add('fr-not-empty');
                colorInput.dispatchEvent(new Event('input', { bubbles: true }));
                editor.selection.restore();
            }
            const colorPercentage = popup[0].querySelector(
                '.fr-background-color .fr-percentage input'
            );
            if (colorPercentage) {
                editor.selection.save();
                colorPercentage.value = Boolean(transparent) ? transparent : 100;
                colorPercentage.dispatchEvent(new Event('input', { bubbles: true }));
                editor.selection.restore();
            }
        }
        function setBackgroundColor(selectedColor) {
            const popup = editor.popups.get('customPlugin.buttonBackground');
            const transparentValue = popup[0]
                .querySelector('.fr-background-color .fr-percentage input')
                .value.replace('%', ''); // 去除 '%'
            const transparent = Number(transparentValue) / 100;
            const hexColor =
                selectedColor ||
                popup[0].querySelector('.fr-background-color .fr-color input').value;
            const color = editor.helpers.HEXtoRGB(hexColor);
            const coverColor = RGBtoRGBA(color, transparent);

            if (color) {
                createBackground({ color: coverColor });
            } else {
                const value = popup[0].querySelector('.fr-background-color .fr-color input').value;
                if (value) {
                    createBackground({ color: coverColor });
                }
            }
        }
        function removeColor(popup) {
            const selectedColor = popup[0].querySelector('.fr-selected-color');
            if (selectedColor) {
                selectedColor.parentNode.removeChild(selectedColor);
            }
        }
        function convertRGBAToObj(rgba) {
            const rgbaArray = rgba.match(/[\d.]+/g).map(Number);
            return {
                color: `rgb(${rgbaArray[0]}, ${rgbaArray[1]}, ${rgbaArray[2]})`,
                transparent: rgbaArray[3] * 100
            };
        }
        function translate(word) {
            return editor.language.translate(word);
        }
        function RGBtoRGBA(rgb, transparent) {
            return rgb.replace('rgb', 'rgba').replace(')', `, ${transparent})`);
        }
        function hidePopup() {
            editor.popups.hide('customPlugin.buttonBackground');
        }
        function createBackground({ color }) {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            const isSelectCustomButton =
                Boolean(selectOuterElement) &&
                selectOuterElement.classList.contains('custom-button-plugin');

            if (!isSelectCustomButton) return;

            editor.selection.save();

            selectOuterElement.style.backgroundColor = color;
            hidePopup();
        }
        function showPopup() {
            let popup = editor.popups.get('customPlugin.buttonBackground');
            if (!popup) popup = initPopup();
            const btn = editor.selection.element();
            refreshOnShow(popup);
            editor.popups.setContainer('customPlugin.buttonBackground', editor.$sc);
            const rect = btn.getBoundingClientRect();
            const left = rect.left + rect.width / 2 + window.pageXOffset;
            const top = rect.top + rect.height + window.pageYOffset;
            editor.popups.show('customPlugin.buttonBackground', left, top, rect.height);
            popup[0].classList.add('second-popup');
        }

        return {
            showPopup,
            hidePopup,
            setBackgroundColor
        };
    };
    FroalaEditor.RegisterCommand('setBackgroundColor', {
        undo: true,
        callback: function (_e, type) {
            this.buttonBackground.setBackgroundColor(type);
        }
    });
    FroalaEditor.DefineIcon('backgroundColorEdit', {
        SRC: 'https://assets.fevercdn.com/nc/froala_editor/backgroundColor.png',
        ALT: 'backgroundColor',
        template: 'image'
    });
    FroalaEditor.RegisterCommand('backgroundColorEdit', {
        title: 'button_bgColor',
        undo: false,
        refreshAfterCallback: false,
        popup: true,
        callback: function () {
            if (this.popups.isVisible('customPlugin.buttonBackground')) {
                this.popups.hide('customPlugin.buttonBackground');
            } else {
                this.buttonBackground.showPopup();
            }
        },
        plugin: 'buttonBackground'
    });

    //字體顏色
    FroalaEditor.PLUGINS.buttonTextColor = function (editor) {
        // Define the popup template
        function initPopup() {
            let popup_buttons = '';

            const colorElement = createColorElement({
                id: editor.id,
                containerClassName: 'fr-text-color',
                colorPickFunc: 'setTextColor',
                saveFunc: 'setTextColor',
                saveText: translate('OK'),
                clearText: translate('Clear Formatting'),
                colorLabel: translate('HEX Color'),
                opacityLabel: translate('opacity')
            });

            const template = {
                buttons: popup_buttons,
                custom_layer: colorElement
            };
            const popup = editor.popups.create('customPlugin.buttonTextColor', template);
            return popup;
        }
        function refreshOnShow(popup) {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            const isSelectCustomButton =
                Boolean(selectOuterElement) &&
                selectOuterElement.classList.contains('custom-button-plugin');

            if (!isSelectCustomButton) return;

            // 從選中按鈕中獲取背景顏色
            let textColor = getComputedStyle(selectOuterElement).color;
            // 移除之前選擇的顏色
            removeColor(popup);
            if (textColor) {
                let transparent;
                if (textColor.indexOf('rgba') !== -1) {
                    // 將 RGBA 轉換為 RGB 和透明度
                    ({ transparent, color: textColor } = convertRGBAToObj(textColor));
                }
                // 在彈出窗口中重新選擇顏色
                reSelectColor(textColor, transparent, popup);
            }
        }
        function reSelectColor(color, transparent, popup) {
            const hexColor = editor.helpers.RGBToHex(color);
            const colorItem = popup[0].querySelector(
                `.fr-text-color .fr-select-color[data-param1="${hexColor}"]`
            );
            if (colorItem) {
                colorItem.innerHTML +=
                    '<span class="fr-selected-color" aria-hidden="true">\uf00c</span>';
                colorItem.classList.add('fr-active-item');
                colorItem.setAttribute('aria-selected', 'true');
            }
            const colorInput = popup[0].querySelector('.fr-text-color .fr-color input');
            if (colorInput) {
                colorInput.value = hexColor;
                colorInput.classList.add('fr-not-empty');
                colorInput.dispatchEvent(new Event('input', { bubbles: true }));
            }
            const colorPercentage = popup[0].querySelector('.fr-text-color .fr-percentage input');
            if (colorPercentage) {
                colorPercentage.value = Boolean(transparent) ? transparent : 100;
                colorPercentage.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
        function setTextColor(selectedColor) {
            const popup = editor.popups.get('customPlugin.buttonTextColor');
            const transparentValue = popup[0]
                .querySelector('.fr-text-color .fr-percentage input')
                .value.replace('%', ''); // 去除 '%'
            const transparent = Number(transparentValue) / 100;
            const hexColor =
                selectedColor || popup[0].querySelector('.fr-text-color .fr-color input').value;
            const color = editor.helpers.HEXtoRGB(hexColor);
            const coverColor = RGBtoRGBA(color, transparent);

            if (color) {
                createText({ color: coverColor });
            } else {
                const value = popup[0].querySelector('.fr-text-color .fr-color input').value;
                if (value) {
                    createText({ color: coverColor });
                }
            }
        }
        function removeColor(popup) {
            const selectedColor = popup[0].querySelector('.fr-selected-color');
            if (selectedColor) {
                selectedColor.parentNode.removeChild(selectedColor);
            }
        }
        function convertRGBAToObj(rgba) {
            const rgbaArray = rgba.match(/[\d.]+/g).map(Number);
            return {
                color: `rgb(${rgbaArray[0]}, ${rgbaArray[1]}, ${rgbaArray[2]})`,
                transparent: rgbaArray[3] * 100
            };
        }
        function translate(word) {
            return editor.language.translate(word);
        }
        function RGBtoRGBA(rgb, transparent) {
            return rgb.replace('rgb', 'rgba').replace(')', `, ${transparent})`);
        }
        function hidePopup() {
            editor.popups.hide('customPlugin.buttonTextColor');
        }
        function createText({ color }) {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            const isSelectCustomButton =
                Boolean(selectOuterElement) &&
                selectOuterElement.classList.contains('custom-button-plugin');

            if (!isSelectCustomButton) return;

            editor.selection.save();
            selectOuterElement.style.color = color;
            hidePopup();
        }
        function showPopup() {
            let popup = editor.popups.get('customPlugin.buttonTextColor');
            if (!popup) popup = initPopup();
            const btn = editor.selection.element();
            refreshOnShow(popup);
            editor.popups.setContainer('customPlugin.buttonTextColor', editor.$sc);
            const rect = btn.getBoundingClientRect();
            const left = rect.left + rect.width / 2 + window.pageXOffset;
            const top = rect.top + rect.height + window.pageYOffset;
            editor.popups.show('customPlugin.buttonTextColor', left, top, rect.height);
            popup[0].classList.add('second-popup');
        }

        return {
            showPopup,
            hidePopup,
            setTextColor
        };
    };
    FroalaEditor.RegisterCommand('setTextColor', {
        undo: true,
        callback: function (_e, type) {
            this.buttonTextColor.setTextColor(type);
        }
    });
    FroalaEditor.DefineIcon('textColorEdit', {
        NAME: 'textColor',
        SVG_KEY: 'textColor'
    });
    FroalaEditor.RegisterCommand('textColorEdit', {
        title: 'button_textColor',
        undo: false,
        refreshAfterCallback: false,
        popup: true,
        callback: function () {
            if (this.popups.isVisible('customPlugin.buttonTextColor')) {
                this.popups.hide('customPlugin.buttonTextColor');
            } else {
                this.buttonTextColor.showPopup();
            }
        },
        plugin: 'buttonTextColor'
    });

    // align
    FroalaEditor.PLUGINS.buttonAlign = function (editor) {
        function alignButton(alignment) {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            const isSelectCustomButton =
                Boolean(selectOuterElement) &&
                selectOuterElement.classList.contains('custom-button-plugin');

            // 確保選中的元素是按鈕
            if (isSelectCustomButton) {
                const parentParagraph = selectOuterElement.parentNode;
                if (parentParagraph) {
                    parentParagraph.style.textAlign = alignment;
                }
            }
        }

        return {
            alignLeft: function () {
                alignButton('left');
            },
            alignCenter: function () {
                alignButton('center');
            },
            alignRight: function () {
                alignButton('right');
            }
        };
    };
    FroalaEditor.RegisterCommand('buttonAlign', {
        title: 'Align',
        type: 'dropdown',
        icon: 'align-left',
        options: {
            left: 'Align Left',
            center: 'Align Center',
            right: 'Align Right'
        },
        callback: function (_cmd, val) {
            if (val === 'left') {
                this.buttonAlign.alignLeft();
            } else if (val === 'center') {
                this.buttonAlign.alignCenter();
            } else if (val === 'right') {
                this.buttonAlign.alignRight();
            }
        },
        commandIcon: function (cmd) {
            if (cmd === 'alignDropdown-left') {
                return 'align-left';
            } else if (cmd === 'alignDropdown-center') {
                return 'align-center';
            } else if (cmd === 'alignDropdown-right') {
                return 'align-right';
            }
            return 'align-left';
        }
    });

    // padding
    FroalaEditor.PLUGINS.buttonPadding = function (editor) {
        function initPopup() {
            const input = createPadding({
                id: editor.id,
                translate,
                paddingHorizontalValue: '10px',
                paddingVerticalValue: '10px',
                borderRadiusValue: '0px',
                dataCmd: 'setButtonPadding'
            });
            const template = {
                custom_layer: input
            };
            const popup = editor.popups.create('customPlugin.buttonPadding', template);
            return popup;
        }

        function setPadding() {
            const popup = editor.popups.get('customPlugin.buttonPadding');
            const horizontal =
                parseInt(popup[0].querySelector('[id^="fr-layer-padding-horizontal"]').value) || 0;
            const vertical =
                parseInt(popup[0].querySelector('[id^="fr-layer-padding-vertical"]').value) || 0;
            const radius =
                parseInt(popup[0].querySelector('[id^="fr-layer-padding-radius"]').value) || 0;
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            if (selectOuterElement) {
                selectOuterElement.style.paddingLeft = `${horizontal}px`;
                selectOuterElement.style.paddingRight = `${horizontal}px`;
                selectOuterElement.style.paddingTop = `${vertical}px`;
                selectOuterElement.style.paddingBottom = `${vertical}px`;
                selectOuterElement.style.borderRadius = `${radius}px`;
            }
            hidePopup();
        }

        function showPopup() {
            let popup = editor.popups.get('customPlugin.buttonPadding');
            if (!popup) popup = initPopup();
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');

            if (selectOuterElement) {
                // 獲取按鈕的樣式
                const computedStyle = window.getComputedStyle(selectOuterElement);
                const paddingLeft = computedStyle.paddingLeft || '0px';
                const paddingTop = computedStyle.paddingTop || '0px';
                const borderRadius = computedStyle.borderRadius || '0px';

                // 填入當前按鈕的樣式到彈出視窗中的 input
                popup[0].querySelector('[id^="fr-layer-padding-horizontal"]').value = paddingLeft;
                popup[0].querySelector('[id^="fr-layer-padding-vertical"]').value = paddingTop;
                popup[0].querySelector('[id^="fr-layer-padding-radius"]').value = borderRadius;
            }

            editor.popups.setContainer('customPlugin.buttonPadding', editor.$sc);
            const btn = editor.selection.element();
            const rect = btn.getBoundingClientRect();
            const left = rect.left + rect.width / 2 + window.pageXOffset;
            const top = rect.top + rect.height + window.pageYOffset;

            editor.popups.show('customPlugin.buttonPadding', left, top, rect.height);
            popup[0].classList.add('second-popup');
        }

        function hidePopup() {
            editor.popups.hide('customPlugin.buttonPadding');
        }

        function translate(word) {
            return editor.language.translate(word);
        }

        return {
            showPopup,
            hidePopup,
            setPadding
        };
    };
    FroalaEditor.RegisterCommand('setButtonPadding', {
        undo: true,
        callback: function () {
            this.buttonPadding.setPadding();
        }
    });
    FroalaEditor.DefineIcon('buttonPadding', {
        SRC: 'https://assets.fevercdn.com/nc/froala_editor/padding.png',
        ALT: 'buttonPadding',
        template: 'image'
    });
    FroalaEditor.RegisterCommand('buttonPadding', {
        title: 'padding',
        undo: false,
        refreshAfterCallback: false,
        popup: true,
        callback: function () {
            console.log('WTF');
            if (this.popups.isVisible('customPlugin.buttonPadding')) {
                this.popups.hide('customPlugin.buttonPadding');
            } else {
                this.buttonPadding.showPopup();
            }
        },
        plugin: 'buttonPadding'
    });

    // 定義插件
    FroalaEditor.PLUGINS.buttonStyle = function (editor) {
        function setButtonStyle(_cmd, val) {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a'); // 獲取當前選中的元素
            const currentBorderColor = getComputedStyle(selectOuterElement).borderColor;
            const currentBackgroundColor = getComputedStyle(selectOuterElement).backgroundColor;
            const currentTextColor = getComputedStyle(selectOuterElement).color;

            // 判斷透明顏色 (包括 rgba(0, 0, 0, 0))
            const isTransparent = color =>
                color === 'rgba(0, 0, 0, 0)' ||
                color === 'transparent' ||
                color === 'rgb(255, 255, 255)';

            if (val === 'plain') {
                selectOuterElement.style.backgroundColor = 'transparent';
                selectOuterElement.style.border = 'none';
                selectOuterElement.style.color =
                    currentTextColor === 'rgb(255, 255, 255)'
                        ? currentBackgroundColor
                        : currentTextColor;
            } else if (val === 'solid') {
                selectOuterElement.style.backgroundColor = isTransparent(currentBackgroundColor)
                    ? currentTextColor
                    : currentBackgroundColor;
                selectOuterElement.style.border = 'none';
                selectOuterElement.style.color = isTransparent(currentBackgroundColor)
                    ? '#fff'
                    : currentTextColor;
            } else if (val === 'hollow') {
                selectOuterElement.style.backgroundColor = 'transparent';
                selectOuterElement.style.border = `1px solid ${
                    isTransparent(currentBorderColor) ? currentBackgroundColor : currentBorderColor
                }`;
                selectOuterElement.style.color = isTransparent(currentTextColor)
                    ? currentBackgroundColor
                    : currentBorderColor;
            }
        }
        function getCurrentButtonStyle() {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            const currentBorderStyle = getComputedStyle(selectOuterElement).borderStyle;
            const currentBorderColor = getComputedStyle(selectOuterElement).borderColor;
            const currentBackgroundColor = getComputedStyle(selectOuterElement).backgroundColor;

            const isTransparent = color => color === 'rgba(0, 0, 0, 0)' || color === 'transparent';

            if (isTransparent(currentBackgroundColor) && currentBorderStyle === 'none') {
                return 'plain'; // 純文字
            } else if (!isTransparent(currentBackgroundColor)) {
                return 'solid'; // 實心
            } else if (isTransparent(currentBackgroundColor) && currentBorderColor !== 'none') {
                return 'hollow'; // 空心
            }
        }

        return {
            getCurrentButtonStyle,
            setButtonStyle
        };
    };
    FroalaEditor.DefineIcon('buttonStyle', { template: 'text' });
    FroalaEditor.RegisterCommand('buttonStyle', {
        type: 'dropdown',
        options: {
            plain: 'button_style_plain',
            solid: 'button_style_solid',
            hollow: 'button_style_hollow'
        },
        refresh: function ($btn, $dropdown) {
            const currentStyle = this.buttonStyle.getCurrentButtonStyle(); // 獲取當前按鈕的樣式
            const spanTag = $btn.find('span'); // 取得下拉按鈕的標籤
            // 根據樣式更新顯示的值
            if (currentStyle === 'plain') {
                spanTag.text(this.language.translate('button_style_plain'));
            } else if (currentStyle === 'solid') {
                spanTag.text(this.language.translate('button_style_solid'));
            } else if (currentStyle === 'hollow') {
                spanTag.text(this.language.translate('button_style_hollow'));
            }
            // 根據目前的選擇更新選單
            $dropdown.find(`.fr-command[data-param1="${currentStyle}"]`).addClass('fr-active');
        },
        callback: function (cmd, val) {
            const buttonStyleEdit = document.querySelector(
                '.fr-popup .fr-command[data-cmd="buttonStyle"]'
            );
            const spanTag = buttonStyleEdit.querySelector('span');
            if (val === 'plain') {
                spanTag.textContent = this.language.translate('button_style_plain');
                this.buttonStyle.setButtonStyle(cmd, 'plain');
            } else if (val === 'solid') {
                spanTag.textContent = this.language.translate('button_style_solid');
                this.buttonStyle.setButtonStyle(cmd, 'solid');
            } else if (val === 'hollow') {
                spanTag.textContent = this.language.translate('button_style_hollow');
                this.buttonStyle.setButtonStyle(cmd, 'hollow');
            }
        }
    });

    // 定義 Border
    FroalaEditor.PLUGINS.buttonBorder = function (editor) {
        // Define the popup template
        function initPopup() {
            let popup_buttons = '';

            const colorElement = createColorElement({
                id: editor.id,
                containerClassName: 'fr-border-color',
                colorPickFunc: 'setButtonBorder',
                saveFunc: 'setButtonBorder',
                saveText: translate('OK'),
                clearText: translate('Clear Formatting'),
                colorLabel: translate('HEX Color'),
                opacityLabel: translate('opacity'),
                needBorder: true,
                translate
            });

            const template = {
                buttons: popup_buttons,
                custom_layer: colorElement
            };
            const popup = editor.popups.create('customPlugin.buttonBorder', template);
            return popup;
        }
        function refreshOnShow(popup) {
            // 確保選中的是 `.simple-button-plugin` 類別的按鈕
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a'); // 獲取當前選中的元素
            if (!selectOuterElement) {
                return;
            }
            // 從選中按鈕中獲取背景顏色
            let borderWidth = getComputedStyle(selectOuterElement).borderBlockWidth;
            let borderColor = getComputedStyle(selectOuterElement).borderBlockColor;

            // 移除之前選擇的顏色
            removeColor(popup);

            let transparent = null;
            if (borderColor.indexOf('rgba') !== -1) {
                // 將 RGBA 轉換為 RGB 和透明度
                ({ transparent, color: borderColor } = convertRGBAToObj(borderColor));
            }
            // 在彈出窗口中重新選擇顏色
            reSelectColor(borderColor, transparent, borderWidth, popup);
        }
        function reSelectColor(color, transparent, borderWidth, popup) {
            const buttonBorderWidth = popup[0].querySelector('.fr-border-color .fr-border-input');
            if (buttonBorderWidth) {
                editor.selection.save();
                buttonBorderWidth.value = borderWidth;
                buttonBorderWidth.classList.add('fr-not-empty');
                buttonBorderWidth.dispatchEvent(new Event('input', { bubbles: true }));
                editor.selection.restore();
            }
            const hexColor = editor.helpers.RGBToHex(color);
            const colorItem = popup[0].querySelector(
                `.fr-border-color .fr-select-color[data-param1="${hexColor}"]`
            );
            if (colorItem) {
                colorItem.innerHTML +=
                    '<span class="fr-selected-color" aria-hidden="true">\uf00c</span>';
                colorItem.classList.add('fr-active-item');
                colorItem.setAttribute('aria-selected', 'true');
            }
            const colorInput = popup[0].querySelector('.fr-border-color .fr-color input');
            if (colorInput) {
                editor.selection.save();
                colorInput.value = hexColor;
                colorInput.classList.add('fr-not-empty');
                colorInput.dispatchEvent(new Event('input', { bubbles: true }));
                editor.selection.restore();
            }
            const colorPercentage = popup[0].querySelector('.fr-border-color .fr-percentage input');
            if (colorPercentage) {
                editor.selection.save();
                colorPercentage.value = Boolean(transparent) ? transparent : 100;
                colorPercentage.dispatchEvent(new Event('input', { bubbles: true }));
                editor.selection.restore();
            }
        }
        function removeColor(popup) {
            const selectedColor = popup[0].querySelector('.fr-selected-color');
            if (selectedColor) {
                selectedColor.parentNode.removeChild(selectedColor);
            }
        }
        function convertRGBAToObj(rgba) {
            const rgbaArray = rgba.match(/[\d.]+/g).map(Number);
            return {
                color: `rgb(${rgbaArray[0]}, ${rgbaArray[1]}, ${rgbaArray[2]})`,
                transparent: rgbaArray[3] * 100
            };
        }
        function setButtonBorder(selectedColor) {
            const popup = editor.popups.get('customPlugin.buttonBorder');
            const transparentValue = popup[0]
                .querySelector('.fr-border-color .fr-percentage input')
                .value.replace('%', ''); // 去除 '%'
            const border =
                parseInt(popup[0].querySelector('[id^="fr-layer-custom-border"]').value) || 0;
            const transparent = Number(transparentValue) / 100;
            const hexColor =
                selectedColor || popup[0].querySelector('.fr-border-color .fr-color input').value;
            const color = editor.helpers.HEXtoRGB(hexColor);
            const coverColor = RGBtoRGBA(color, transparent);

            if (color) {
                createBorder({ color: coverColor, border });
            } else {
                const value = popup[0].querySelector('.fr-border-color .fr-color input').value;
                if (value) {
                    createBorder({ color: coverColor, border });
                }
            }
        }
        function translate(word) {
            return editor.language.translate(word);
        }
        function RGBtoRGBA(rgb, transparent) {
            return rgb.replace('rgb', 'rgba').replace(')', `, ${transparent})`);
        }
        function hidePopup() {
            editor.popups.hide('customPlugin.buttonBorder');
        }
        function createBorder({ color, border }) {
            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            const borderStyle = getComputedStyle(selectOuterElement).borderBlockStyle;
            if (!selectOuterElement) {
                return;
            }
            selectOuterElement.style.border = `${border}px ${borderStyle} ${color}`;
            hidePopup();
        }
        function showPopup() {
            let popup = editor.popups.get('customPlugin.buttonBorder');
            if (!popup) popup = initPopup();

            const selection = editor.selection.element();
            const selectOuterElement = selection.closest('a');
            refreshOnShow(popup);
            editor.popups.setContainer('customPlugin.buttonBorder', editor.$sc);
            const rect = selectOuterElement.getBoundingClientRect();
            const left = rect.left + rect.width / 2 + window.pageXOffset;
            const top = rect.top + rect.height + window.pageYOffset;
            editor.popups.show('customPlugin.buttonBorder', left, top, rect.height);
            popup[0].classList.add('second-popup');
        }

        return {
            showPopup,
            hidePopup,
            setButtonBorder
        };
    };
    FroalaEditor.RegisterCommand('setButtonBorder', {
        undo: true,
        callback: function (_e, type) {
            this.buttonBorder.setButtonBorder(type);
        }
    });
    FroalaEditor.DefineIcon('borderOuterIcon', {
        SRC: 'https://assets.fevercdn.com/nc/froala_editor/border.png',
        ALT: 'border-outer',
        template: 'image'
    });
    FroalaEditor.RegisterCommand('borderOuterButton', {
        title: 'border_style',
        icon: 'borderOuterIcon',
        undo: false,
        refreshAfterCallback: false,
        popup: true,
        callback: function () {
            if (this.popups.isVisible('customPlugin.buttonBorder')) {
                this.popups.hide('customPlugin.buttonBorder');
            } else {
                this.buttonBorder.showPopup();
            }
        },
        plugin: 'buttonBorder'
    });
})();
